import React from "react";
import block from "bem-cn";

import { shallowEqual, useSelector } from "react-redux";
import NotificationItem from "../NotificationItem/NotificationItem";

import './NotificationsList.scss'
import Spinner from "components/Spinner";

const b = block('notifications-list');
const NotificationsList = ({ items, setActiveItem, hideNotification }) => {
  const locale = useSelector(state => state.locale.locale, shallowEqual);
  const { actionProcessing } = useSelector(state => state.notifications);
  const notifications = items.map((item) => <NotificationItem hideNotification={hideNotification} setActiveItem={setActiveItem} key={item.id} item={item} />);

  return (
    <div className={b()}>
      <Spinner isLoading={actionProcessing}/>
      {notifications}
      {notifications.length === 0 && <div className={b('empty')}>{locale.noNotifications}</div>}
    </div>
  )
};

export default NotificationsList;